/* ============================================================
   1. TEMA (claro / oscuro) — cross-fade de CSS Variables
   ============================================================ */
const root = document.documentElement;
const themeIco = document.getElementById('theme-ico');
const ICO_SUN  = '<circle cx="12" cy="12" r="4.5"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>';
const ICO_MOON = '<path d="M20 14.5A8.5 8.5 0 019.5 4a8.5 8.5 0 1010.5 10.5z"/>';

function applyTheme(dark){
  root.setAttribute('data-theme', dark ? 'dark' : 'light');
  themeIco.innerHTML = dark ? ICO_MOON : ICO_SUN;
  // La escena 3D lee el fondo del tema activo (se define más abajo, tras cargar el motor)
  if (typeof window.syncSceneTheme === 'function') window.syncSceneTheme(dark);
}
// Siempre arranca en claro, sin importar el SO del visitante — el botón de
// tema sigue funcionando para que el usuario cambie a oscuro a mano durante
// su sesión, sólo el estado inicial deja de seguir prefers-color-scheme.
applyTheme(false);
document.getElementById('theme-btn').addEventListener('click', () => {
  applyTheme(root.getAttribute('data-theme') !== 'dark');
});

/* ============================================================
   2. NAV + año
   ============================================================ */
const nav = document.getElementById('nav');
addEventListener('scroll', () => nav.classList.toggle('scrolled', scrollY > 12), {passive:true});
document.getElementById('year').textContent = new Date().getFullYear();

/* Menú de hamburguesa (sólo móvil). Abre el mismo <nav class="nav-links">
   del escritorio, que en ese breakpoint el CSS convierte en un cajón.
   Se cierra al elegir un destino, con Escape, o si la pantalla crece
   hasta el tamaño de escritorio — sin esto último, quien gire el teléfono
   o agrande la ventana se quedaría con el estado "abierto" pegado y el
   menú del escritorio en un estado raro. */
(function initMenuMovil(){
  const nav = document.getElementById('nav');
  const burger = document.getElementById('nav-burger');
  const links = document.getElementById('nav-links');
  if (!nav || !burger || !links) return;

  function abrir(v){
    nav.classList.toggle('menu-abierto', v);
    burger.setAttribute('aria-expanded', String(v));
    burger.setAttribute('aria-label', v ? 'Cerrar menú' : 'Abrir menú');
    // Al cerrar el cajón, el desplegable de adentro también se colapsa:
    // si no, al reabrir aparecería ya expandido sin que nadie lo pidiera.
    if (!v) nav.querySelectorAll('.nav-drop.open').forEach(d => {
      d.classList.remove('open');
      const b = d.querySelector('.nav-drop-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  burger.addEventListener('click', e => {
    e.stopPropagation(); // que el listener de "clic fuera" del desplegable no lo reabra/cierre en el mismo gesto
    abrir(!nav.classList.contains('menu-abierto'));
  });
  // Delegación en vez de enganchar cada <a> uno por uno: las redes se
  // mueven al cajón DESPUÉS de que corre esto (ver más abajo), así que
  // un forEach sobre los enlaces de ese momento se las perdería.
  links.addEventListener('click', e => { if (e.target.closest('a')) abrir(false); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && nav.classList.contains('menu-abierto')) { abrir(false); burger.focus(); }
  });
  matchMedia('(min-width:861px)').addEventListener('change', e => { if (e.matches) abrir(false); });

  /* Las 3 redes viven en la barra en escritorio, pero en una pantalla de
     390px no caben junto al logo, la hamburguesa, el tema, el carrito y
     "Cotizar" — antes de esto el logo y el botón "Cotizar" quedaban
     literalmente fuera de la pantalla. Se MUEVE el nodo entre la barra y
     el cajón según el ancho, en vez de duplicar el markup: así sólo hay
     un juego de enlaces que mantener. */
  const social = document.getElementById('nav-social');
  const navRight = document.querySelector('.nav-right');
  if (social && navRight) {
    const mqEscritorio = matchMedia('(min-width:861px)');
    const colocar = esEscritorio => {
      if (esEscritorio) {
        if (social.parentElement !== navRight) navRight.insertBefore(social, navRight.firstChild);
      } else if (social.parentElement !== links) {
        links.appendChild(social); // al final del cajón, después de Nosotros
      }
    };
    colocar(mqEscritorio.matches);
    mqEscritorio.addEventListener('change', e => colocar(e.matches));
  }
})();

/* Dropdown "Productos" — abre con hover en desktop (puro CSS, ver
   .nav-drop:hover en site.css) y con tap/click en cualquier dispositivo
   (este toggle). Cerrar al tocar fuera o con Escape, como cualquier menú
   nativo. */
document.querySelectorAll('.nav-drop').forEach(drop => {
  const btn = drop.querySelector('.nav-drop-btn');
  const setOpen = open => {
    drop.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', String(open));
  };
  btn.addEventListener('click', () => setOpen(!drop.classList.contains('open')));
  document.addEventListener('click', e => {
    if (!drop.contains(e.target)) setOpen(false);
  });
  drop.addEventListener('keydown', e => {
    if (e.key === 'Escape') { setOpen(false); btn.focus(); }
  });
});

/* Tile "todos" del collage del hero ([data-shuffle]): Liquid no tiene
   filtro `shuffle` (eso es Jekyll, no Shopify), así que el server manda
   hasta 8 fotos reales de producto y aquí se eligen 3 al azar por visita.
   El truco es puramente de DOM: se reordenan los <img> elegidos como
   primeros 3 hijos y el crossfade CSS existente (.qr-carousel img:first-
   child/:nth-child) sigue funcionando sin tocarlo, porque ese CSS apunta
   a POSICIÓN en el DOM, no a qué imagen es. También se traslada el atributo
   data-alt (puesto en TODAS las imágenes desde Liquid) al que termine de
   primero, ya que sólo la que Liquid renderizó como forloop.first trae alt
   real — las demás nacen con alt="" + aria-hidden. */
document.querySelectorAll('[data-shuffle]').forEach(tile => {
  const imgs = Array.from(tile.querySelectorAll('img'));
  if (imgs.length <= 3) return;
  for (let i = imgs.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [imgs[i], imgs[j]] = [imgs[j], imgs[i]];
  }
  const chosen = imgs.slice(0, 3);
  imgs.slice(3).forEach(img => img.remove());
  chosen.forEach((img, i) => {
    tile.appendChild(img); // reordena: fija su posición final 1/2/3
    if (i === 0) {
      img.alt = img.dataset.alt || '';
      img.removeAttribute('aria-hidden');
      img.loading = 'eager';
    } else {
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
    }
  });
});

/* ============================================================
   3. MOVIMIENTO (GSAP) — patrones base del estudio:
      reveal con stagger + parallax suave. Degrada sin JS.
   ============================================================ */
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

if (window.gsap && window.ScrollTrigger && !reduceMotion) {
  gsap.registerPlugin(ScrollTrigger);

  // GSAP oculta (no el CSS) para poder devolver el control con clearProps
  gsap.set('.rv', {opacity:0});
  const CLEAR = 'all';   // al terminar, el CSS recupera rotación y :hover

  // Entrada del hero — se espera a las fuentes porque SplitText mide cada
  // carácter: si Hanken Grotesk llega tarde, las posiciones salen mal.
  // OJO al tocar esta secuencia: más arriba se hace gsap.set('.rv',
  // {opacity:0}) sobre TODO el sitio, así que cualquier elemento con
  // clase .rv en la portada que NO aparezca aquí se queda invisible para
  // siempre. Pasó exactamente eso cuando la portada cambió a imagen: el
  // .hero-banner traía .rv pero nadie lo animaba de vuelta, y la portada
  // se veía vacía. Si agregas un elemento .rv a la portada, agrégalo
  // también a esta línea de tiempo.
  const buildHeroTimeline = () => {
    const tl = gsap.timeline({defaults:{ease:'power2.out'}});

    // La imagen entra primero: es el mensaje principal de la página.
    // El <h1> ya no se anima porque ahora es .sr-only (invisible, sólo
    // para buscadores y lectores de pantalla) — animar algo que nadie ve
    // sería trabajo tirado, y SplitText sobre un elemento recortado a 1px
    // mide mal.
    tl.fromTo('.hero-banner',            {opacity:0, y:26, scale:.985}, {opacity:1, y:0, scale:1, duration:.85, clearProps:CLEAR})
      .fromTo('.marquee-hero',           {opacity:0, y:16},             {opacity:1, y:0, duration:.6, clearProps:CLEAR}, '-=.45')
      .fromTo('.hero-actions',           {opacity:0, y:20},             {opacity:1, y:0, duration:.6, clearProps:CLEAR}, '-=.35')
      .fromTo('.hero-bestsellers-head',  {opacity:0, y:20},             {opacity:1, y:0, duration:.6, clearProps:CLEAR}, '-=.35')
      .fromTo('.hero-best-card',         {opacity:0, y:36, scale:.96},  {opacity:1, y:0, scale:1, duration:.8, stagger:.12, clearProps:CLEAR}, '-=.45');
  };
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(buildHeroTimeline);
  else buildHeroTimeline();

  // Reveal por sección. Se expone porque el catálogo inyecta sus tarjetas
  // después de este pase inicial y necesita animarlas al llegar. Los
  // títulos h2 quedan FUERA de este lote: tienen su propio reveal palabra
  // por palabra más abajo (mismo tratamiento que el <h1> del hero) — si
  // este fromTo también los tomara, competirían por el mismo elemento.
  const revealSection = sec => {
    const items = [...sec.querySelectorAll('.rv:not([data-rv-listo])')].filter(el => el.tagName !== 'H2');
    if (!items.length) return;
    items.forEach(el => el.setAttribute('data-rv-listo', ''));
    gsap.set(items, {opacity:0});
    gsap.fromTo(items, {opacity:0, y:30}, {
      opacity:1, y:0, duration:.75, stagger:.07, ease:'power2.out', clearProps:CLEAR,
      scrollTrigger:{trigger:sec, start:'top 82%', once:true}
    });
  };
  gsap.utils.toArray('.sec').forEach(revealSection);
  window.revelarSeccion = sec => { revealSection(sec); ScrollTrigger.refresh(); };

  // Títulos de sección palabra por palabra al entrar en scroll — mismo
  // gesto "material depositándose" del <h1> del hero, aplicado a cada
  // <h2 class="rv"> del sitio. Antes sólo el hero tenía este tratamiento;
  // el resto sólo hacía fade+y con el resto del bloque .rv, mucho más
  // discreto que lo que se ve en el hero.
  const revealHeadings = () => {
    if (!window.SplitText) return;
    gsap.utils.toArray('.sec h2.rv').forEach(h2 => {
      gsap.set(h2, {opacity:1});
      const split = new SplitText(h2, {type:'words'});
      gsap.fromTo(split.words,
        {opacity:0, yPercent:100, filter:'blur(6px)'},
        {opacity:1, yPercent:0, filter:'blur(0px)', duration:.7, stagger:.045,
         ease:'back.out(1.5)',
         scrollTrigger:{trigger:h2, start:'top 85%', once:true},
         onComplete(){ split.revert(); gsap.set(h2, {clearProps:'all'}); }});
    });
  };
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(revealHeadings);
  else revealHeadings();

  // Botones magnéticos — el CTA sigue un poco al cursor cuando está cerca,
  // como si lo atrajera, y suelta con un rebote suave al salir. Sólo en
  // dispositivos con mouse de verdad (matchMedia): en touch no hay hover
  // que perseguir y el primer tap ya dispara el click. Sólo .btn-primary:
  // .icon-btn ya tiene su propio hover con rotación en CSS y no vale la
  // pena pisarlo (GSAP escribiría el transform completo y se lo comería).
  if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.querySelectorAll('.btn-primary').forEach(btn => {
      const strength = .35;
      const xTo = gsap.quickTo(btn, 'x', {duration:.5, ease:'power3'});
      const yTo = gsap.quickTo(btn, 'y', {duration:.5, ease:'power3'});
      btn.addEventListener('mousemove', e => {
        const r = btn.getBoundingClientRect();
        xTo((e.clientX - r.left - r.width / 2) * strength);
        yTo((e.clientY - r.top - r.height / 2) * strength);
      });
      btn.addEventListener('mouseleave', () => {
        gsap.to(btn, {x:0, y:0, duration:.6, ease:'elastic.out(1,.4)'});
      });
    });
  }

  // Conteo ascendente de las estadísticas del hero (48 h · 10 · 1 pza) —
  // separa el número inicial del sufijo (unidad/texto) con regex, cuenta
  // sólo el número y reinserta el sufijo tal cual en cada frame.
  gsap.utils.toArray('.hero-stats strong').forEach(el => {
    const m = el.textContent.match(/^(\d+)(.*)$/);
    if (!m) return;
    const target = parseInt(m[1], 10), suffix = m[2];
    const counter = {n:0};
    gsap.to(counter, {
      n:target, duration:1.4, ease:'power2.out', snap:{n:1},
      scrollTrigger:{trigger:'.hero-stats', start:'top 85%', once:true},
      onUpdate(){ el.textContent = counter.n + suffix; },
    });
  });

  // Parallax suave de las tarjetas de Los Más Vendidos del hero
  gsap.utils.toArray('.hero-best-card').forEach((card, i) => {
    gsap.to(card, {
      yPercent: -4, ease:'none',
      scrollTrigger:{trigger:'.hero', start:'top top', end:'bottom top', scrub:.6},
    });
  });

  // Inclinación 3D suave de las tarjetas del catálogo al pasar el mouse —
  // se calcula sobre la posición relativa del cursor dentro de la tarjeta,
  // así que cada una se inclina hacia donde entra el cursor, no a un
  // ángulo fijo. Delegado en el grid (las tarjetas las inyecta catalog.js
  // después de este arranque) para no tener que re-engancharlo cada vez
  // que se repinta el filtro. Incluye la misma elevación y:-9px que ya
  // traía `.card:hover` en CSS —GSAP escribe el `transform` inline en
  // cuanto se mueve el mouse una vez, y desde ahí una regla de hover sin
  // !important nunca vuelve a aplicarse (el inline gana siempre); así que
  // el levantado tiene que salir de aquí, no de CSS, o la tarjeta perdía
  // su "despegue" en cuanto se le pasaba el mouse por encima.
  if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
    const grid = document.getElementById('catalogo-grid');
    grid?.addEventListener('mousemove', e => {
      const card = e.target.closest('.card');
      if (!card) return;
      const r = card.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5;
      gsap.to(card, {rotateY:px * 10, rotateX:py * -10, y:-9, duration:.4, ease:'power2.out', transformPerspective:700});
    });
    grid?.addEventListener('mouseleave', e => {
      const card = e.target.closest?.('.card');
      const cards = card ? [card] : grid.querySelectorAll('.card');
      // clearProps, no {rotateY:0,...}: así CSS recupera el control del
      // hover normal (borde/sombra) apenas el cursor sale de la tarjeta.
      gsap.to(cards, {rotateY:0, rotateX:0, y:0, duration:.5, ease:'power2.out', clearProps:'transform'});
    }, true);
  }
} else {
  gsap?.set?.('.rv', {opacity:1});
  window.revelarSeccion = () => {};
}

/* ============================================================
   4. FORMULARIO — mismo patrón CRM que el paso 6 del personalizador 3D
      (deep link de WhatsApp, sin backend): wa.me no permite adjuntar
      archivo por link, así que este formulario general no descarga nada,
      sólo abre el chat con el mensaje ya redactado. Número compartido en
      window.KREATIVA3D_WHATSAPP_NUMBER — reemplazar antes de publicar.
   ============================================================ */
// El número real lo inyecta layout/theme.liquid desde el ajuste global del
// editor de temas (Configuración → WhatsApp), ANTES de cargar este script.
// El valor de aquí es sólo la red de seguridad por si esa inyección
// faltara — nunca debe pisar lo que ya vino del tema.
window.KREATIVA3D_WHATSAPP_NUMBER = window.KREATIVA3D_WHATSAPP_NUMBER || '524442040122';
// #quote-form sólo existe en la sección home (kreativa3d-home.liquid) — este
// script carga en TODAS las páginas (catálogo, producto, carrito), así que
// sin este guard, getElementById('quote-form') regresa null ahí y el
// .addEventListener revienta con un TypeError en cada carga de esas páginas.
const quoteForm = document.getElementById('quote-form');
if (quoteForm) quoteForm.addEventListener('submit', (e) => {
  e.preventDefault();
  const note = document.getElementById('form-note');
  const data = Object.fromEntries(new FormData(e.target));
  if (!data.nombre?.trim() || !data.tel?.trim()) {
    note.textContent = 'Faltan tu nombre y tu WhatsApp.';
    note.style.color = 'var(--p-primary)';
    return;
  }
  const number = window.KREATIVA3D_WHATSAPP_NUMBER;
  if (!number || number.startsWith('PENDIENTE')) {
    note.textContent = 'Demo: aquí se abriría WhatsApp con tu solicitud.';
    note.style.color = 'var(--p-secondary)';
    return;
  }
  const message = `¡Hola Kreativa3D! Quiero cotizar.\n\nNombre: ${data.nombre.trim()}\nWhatsApp: ${data.tel.trim()}` +
    (data.mensaje?.trim() ? `\nNecesito: ${data.mensaje.trim()}` : '');
  window.open(`https://wa.me/${number}?text=${encodeURIComponent(message)}`, '_blank');
  note.textContent = 'Te llevamos a WhatsApp para confirmar.';
  note.style.color = 'var(--p-secondary)';
  e.target.reset();
});

/* ============================================================
   5. GLOBO FLOTANTE DE WHATSAPP — el cliente lo tenía en el sitio
      anterior (ícono fijo, mensajes rotativos tipo "¿Puedo ayudarte?",
      sonido al aparecer, clic abre WhatsApp con el número real) y pidió
      traerlo de vuelta con la misma función. Único cambio pedido: el
      sonido original le parecía molesto — se reemplaza por una campanita
      generada con Web Audio API afinada en 432Hz (sin archivo de audio
      que cargar ni depender de un formato/licencia).
   ============================================================ */
(function initWhatsAppFloat(){
  const btn = document.getElementById('wa-float-btn');
  const bubble = document.getElementById('wa-float-bubble');
  const textEl = document.getElementById('wa-float-text');
  const closeBtn = document.getElementById('wa-float-bubble-close');
  // El globo se puede apagar por completo desde el editor de temas — en
  // ese caso el layout ni siquiera imprime el markup y este guard corta.
  if (!btn || !bubble || !textEl || !closeBtn) return;

  // Config que viene del editor de temas vía layout/theme.liquid. Los
  // defaults de aquí sólo aplican si esa inyección faltara.
  const CFG = window.KREATIVA3D_WA_FLOAT || {};
  const DEFAULT_GREETINGS = [
    '¿Puedo ayudarte?',
    '¿Tienes dudas? Aquí estamos',
    'Escríbenos, respondemos rápido',
    'Cotiza tu pieza por WhatsApp',
    '¿En qué te ayudamos hoy?',
  ];
  // El cliente puede dejar mensajes vacíos en el editor para usar menos de
  // 5 — se filtran aquí. Si los vacía TODOS, se cae a los de fábrica en vez
  // de mostrar una burbuja en blanco.
  const configured = (CFG.greetings || []).filter(g => typeof g === 'string' && g.trim());
  const GREETINGS = configured.length ? configured : DEFAULT_GREETINGS;
  const SOUND_ON = CFG.sound !== false; // sólo un false explícito lo apaga

  // sessionStorage (no localStorage): la insistencia se apaga por el
  // resto de ESA visita si la cierran o le dan clic, pero vuelve a
  // aparecer si regresan otro día — no queremos "enterrarla" para
  // siempre por una sola sesión.
  const DISMISS_KEY = 'k3d-wa-float-dismissed';
  let dismissed = sessionStorage.getItem(DISMISS_KEY) === '1';
  let cycleTimer = null;
  let hideTimer = null;
  let greetingIndex = 0;

  function stopCycling(){
    dismissed = true;
    sessionStorage.setItem(DISMISS_KEY, '1');
    clearTimeout(cycleTimer);
    clearTimeout(hideTimer);
    bubble.classList.remove('visible');
  }

  // -- Campanita 432Hz (Web Audio API, sin archivo) ------------------------
  // Los navegadores bloquean audio sin gesto previo del visitante — el
  // AudioContext sólo se crea en la primera interacción real (clic, tecla,
  // scroll, toque). Si el globo aparece antes de esa primera interacción,
  // esa vez no suena; a partir de ahí sí, en cada reaparición.
  let audioCtx = null;
  function unlockAudio(){
    if (audioCtx) return;
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  ['click', 'keydown', 'touchstart', 'scroll'].forEach(evt =>
    addEventListener(evt, unlockAudio, {once: true, passive: true})
  );

  function playBell(){
    if (!SOUND_ON) return; // apagable desde el editor de temas
    if (!audioCtx || audioCtx.state === 'suspended') return;
    const now = audioCtx.currentTime;
    // Fundamental en 432Hz + dos armónicos (2x, 3x) más suaves, cada uno
    // con su propia caída exponencial — así suena a campanita real, no a
    // un beep plano de un solo tono.
    [
      {freq: 432,     gain: .5,  decay: 1.6},
      {freq: 432 * 2, gain: .18, decay: 1.1},
      {freq: 432 * 3, gain: .08, decay: .8},
    ].forEach(({freq, gain, decay}) => {
      const osc = audioCtx.createOscillator();
      const g = audioCtx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      g.gain.setValueAtTime(0, now);
      g.gain.linearRampToValueAtTime(gain, now + .012);
      g.gain.exponentialRampToValueAtTime(.0001, now + decay);
      osc.connect(g);
      g.connect(audioCtx.destination);
      osc.start(now);
      osc.stop(now + decay + .05);
    });
  }

  function showBubble(){
    if (dismissed) return;
    textEl.textContent = GREETINGS[greetingIndex % GREETINGS.length];
    greetingIndex++;
    bubble.classList.add('visible');
    playBell();
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => bubble.classList.remove('visible'), 6000);
  }

  function scheduleNext(delay){
    clearTimeout(cycleTimer);
    cycleTimer = setTimeout(() => {
      showBubble();
      scheduleNext(24000); // reaparece cada ~24s mientras no la cierren/den clic
    }, delay);
  }

  if (!dismissed) scheduleNext(6000); // primera aparición a los 6s de cargar la página

  closeBtn.addEventListener('click', (e) => { e.preventDefault(); stopCycling(); });
  btn.addEventListener('click', stopCycling); // ya logró su objetivo, deja de insistir

  const waNumber = window.KREATIVA3D_WHATSAPP_NUMBER;
  const waMessage = (CFG.prefill && CFG.prefill.trim()) || '¡Hola Kreativa3D! Tengo una pregunta.';
  if (waNumber && !waNumber.startsWith('PENDIENTE')) {
    btn.href = `https://wa.me/${waNumber}?text=${encodeURIComponent(waMessage)}`;
  }
})();

/* ============================================================
   6. "ENVÍANOS TU LOGO" (página de producto) — abre WhatsApp con los
      datos del producto que el visitante está viendo, ya redactados,
      y le avisa que adjunte su logotipo en el chat.

      POR QUÉ NO PEDIMOS EL ARCHIVO AQUÍ: WhatsApp no permite que una
      página web le pase un adjunto. Hubo una versión con selector de
      archivo que intentaba el camino nativo del sistema (Web Share API
      con files); se probó en uso real y el archivo NO llegaba junto al
      mensaje, así que pedirle el archivo en esta página sólo agregaba
      un paso inútil antes de que igual tuviera que adjuntarlo a mano en
      WhatsApp. Ahora es un solo clic y el aviso dice qué sigue.

      El número sale de window.KREATIVA3D_WHATSAPP_NUMBER, que viene del
      ajuste global del editor de temas (Configuración → WhatsApp).
   ============================================================ */
(function initProductLogoSend(){
  const root = document.getElementById('pdp-logo-send');
  if (!root) return; // site-ui.js carga en todo el sitio; esto sólo existe en producto

  const btn   = document.getElementById('pdp-logo-btn');
  const aviso = document.getElementById('pdp-logo-aviso');
  if (!btn || !aviso) return;

  // Arma el mensaje con lo que el visitante tiene seleccionado EN ESE
  // momento: la variante y la cantidad se leen del formulario nativo de
  // Shopify que ya vive en esta página, no de una copia desincronizada.
  function buildMessage(){
    const title = root.dataset.productTitle || document.title;
    const url   = root.dataset.productUrl || location.href;
    const price = root.dataset.productPrice || '';

    const variantSel = document.getElementById('pdp-variant-select');
    const variant = variantSel && variantSel.selectedIndex >= 0
      ? variantSel.options[variantSel.selectedIndex].textContent.trim()
      : '';

    const qtyEl = document.getElementById('pdp-qty-input');
    const qty = qtyEl && qtyEl.value ? qtyEl.value : '1';

    let msg = '¡Hola Kreativa3D! Quiero personalizar este producto con mi logo.\n\n';
    msg += `Producto: ${title}\n`;
    if (variant) msg += `Variante: ${variant}\n`;
    msg += `Cantidad: ${qty}\n`;
    if (price) msg += `Precio de lista: ${price}\n`;
    msg += `Link: ${url}\n`;
    msg += '\n(Te adjunto mi logotipo en este chat.)';
    return msg;
  }

  btn.addEventListener('click', () => {
    const number = window.KREATIVA3D_WHATSAPP_NUMBER;
    if (!number || String(number).startsWith('PENDIENTE')) {
      aviso.querySelector('p').textContent = 'Falta configurar el número de WhatsApp de la tienda.';
      aviso.removeAttribute('hidden');
      return;
    }
    // El aviso se muestra ANTES de abrir, y la apertura ocurre dentro del
    // mismo gesto de clic — si se retrasara con un setTimeout, el
    // navegador la trataría como ventana emergente y la bloquearía.
    aviso.removeAttribute('hidden');
    requestAnimationFrame(() => aviso.classList.add('visible'));
    window.open(`https://wa.me/${number}?text=${encodeURIComponent(buildMessage())}`, '_blank', 'noopener');
  });
})();

/* ============================================================
   7. FIRMA DEL ESTUDIO — saludo en la consola del navegador.
      Huella visual cero: sólo lo ve quien abre las herramientas de
      desarrollo, que suele ser justo la persona que quiere saber
      quién construyó el sitio. El isotipo va con la "E" en el amarillo
      de marca del cliente, no en el nuestro: la casa es suya.
   ============================================================ */
(function firmaEstudio(){
  try {
    if (!window.console || !console.log) return;
    const titulo = 'color:#FFD500;background:#111111;font-size:15px;font-weight:700;padding:10px 16px;border-radius:8px 8px 0 0;font-family:monospace;line-height:1.5';
    const cuerpo = 'color:#111111;background:#FFD500;font-size:11px;padding:8px 16px;border-radius:0 0 8px 8px;font-family:monospace;line-height:1.6';
    console.log(
      '%c R E vrbMX %c\n Diseño y desarrollo de kreativa3d.mx \n Three.js · Vanilla JS · Sin plantillas \n Sin atajos ni plantillas frías. ',
      titulo, cuerpo
    );
  } catch (e) { /* una firma jamás debe romper el sitio */ }
})();
